import { filterOperators } from '../filterOperators';
export const advancedFilterOperators = Object.freeze([
	{
		label: '= is',
		value: filterOperators.Equal,
	},
	{
		label: '≠ is not',
		value: filterOperators.NotEqual,
	},
	{
		label: '> is greater',
		value: filterOperators.GreaterThan,
	},
	{
		label: '≥ is greater or equal',
		value: filterOperators.GreaterOrEqualThan,
	},
	{
		label: '< is less',
		value: filterOperators.LowerThan,
	},
	{
		label: '≤ is less or equal',
		value: filterOperators.LowerOrEqualTahn,
	},
	{
		label: 'contains',
		value: filterOperators.Contains,
	},
	{
		label: 'does not contain',
		value: filterOperators.DoesNotContain,
	},
	{
		label: 'starts with',
		value: filterOperators.StartsWith,
	},
	{
		label: 'is blank',
		value: filterOperators.IsBlank,
	},
	{
		label: 'is not blank',
		value: filterOperators.IsNotBlank,
	},
	{
		label: 'is one of (e.g., x, y, z...)',
		value: filterOperators.IsOneOf,
	},
	{
		label: 'is not one of (e.g., not x, y, z...)',
		value: filterOperators.IsNotOneOf,
	},
]);
